import React from 'react';
import { LuCircleAlert, LuCircleCheck, LuInfo, LuTriangleAlert } from 'react-icons/lu';
import { cx } from '../../utils/cx.js';

const TONES = {
  info: { wrap: 'border-blue-200 bg-blue-50 text-blue-800 dark:border-blue-900/60 dark:bg-blue-950/40 dark:text-blue-200', icon: LuInfo },
  brand: { wrap: 'border-brand-200 bg-brand-50 text-brand-800 dark:border-brand-800 dark:bg-brand-950 dark:text-brand-200', icon: LuInfo },
  success: { wrap: 'border-green-200 bg-green-50 text-green-800 dark:border-green-900/60 dark:bg-green-950/40 dark:text-green-200', icon: LuCircleCheck },
  warning: { wrap: 'border-amber-200 bg-amber-50 text-amber-800 dark:border-amber-900/60 dark:bg-amber-950/40 dark:text-amber-200', icon: LuTriangleAlert },
  danger: { wrap: 'border-red-200 bg-red-50 text-red-800 dark:border-red-900/60 dark:bg-red-950/40 dark:text-red-200', icon: LuCircleAlert },
};

/** Inline message banner. Danger alerts are announced (role="alert"), the others politely. */
const Alert = ({ tone = 'info', title = null, icon, action = null, className = '', children }) => {
  const t = TONES[tone] || TONES.info;
  const Icon = icon || t.icon;
  return (
    <div
      role={tone === 'danger' ? 'alert' : 'status'}
      className={cx('flex items-start gap-3 rounded-xl border px-4 py-3 text-sm text-left', t.wrap, className)}
    >
      <Icon className="mt-0.5 h-4 w-4 flex-shrink-0" aria-hidden />
      <div className="min-w-0 flex-1">
        {title && <p className="font-semibold">{title}</p>}
        {children && <div className={cx(title && 'mt-0.5', 'opacity-90')}>{children}</div>}
      </div>
      {action && <div className="flex-shrink-0">{action}</div>}
    </div>
  );
};

export default Alert;
